import Modal from '@mui/material/Modal';
import { AnimatePresence, motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { api } from '../../../services/api';
import { TimeLineDataType } from '../../../services/apiTypes';
import InstaStories from '../InstaStories';
import { Carousel, CloseModal, NextButton, PrevButton } from './styles';

type FeedPostProps = {
  modal: boolean;
  setModal: (e: boolean) => void;
  initialIndex: number;
};

export default function StoriesModal({ modal, setModal, initialIndex }: FeedPostProps) {
  const [currentIndex, setCurrentIndex] = useState(4);
  const [stories, setStories] = useState<TimeLineDataType[]>([]);

  const goToPrev = (index: number) => {
    if (index < 0) return;
    setCurrentIndex(prevIndex => (prevIndex === 0 ? stories.length - 1 : prevIndex - 1));
  };

  const goToNext = (index: number) => {
    if (index === stories.length) return;
    setCurrentIndex(prevIndex => (prevIndex === stories.length - 1 ? 0 : prevIndex + 1));
  };

  useEffect(() => {
    try {
      api.get(`media/timeline/story`)
        .then(response => {
          if (response && response.status === 200) {
            // console.log('media stories', response.data)
            setStories(response.data)
          }
        })
        .catch(error => {
          console.log(error);
        });
    } catch (error) {
      console.log(error)
    }
  }, [])

  return (
    <>
      <Modal
        open={modal}
        onClose={setModal}
        disableEnforceFocus
        style={{
          display: 'flex',
          backgroundColor: '#1B1B1B',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <>
          <CloseModal onClick={() => setModal(false)}>
            <CloseIcon />
          </CloseModal>
          <div
            style={{
              alignItems: 'center',
              justifyContent: 'center',
              height: '100%',
              width: '100%',
              display: 'flex',
              flexDirection: 'row',
              transform: 'translateX(60%)',
            }}
          >
            <Carousel>
              <motion.div
                style={{ display: 'flex', flexDirection: 'row', gap: 72, height: '100%', width: '100%', justifyContent: 'center', alignItems: 'center' }}
                animate={{ transform: `translateX(-${(currentIndex * 572) - 572}px)` }}
                transition={{ duration: 0.5, ease: [0.04, 0.62, 0.23, 0.98] }}
              >
                <div style={{ height: '800px', width: '500px' }} />
                <div style={{ height: '800px', width: '500px' }} />
                {stories && stories.map((i, index) => (
                  <Card key={index} i={index} selected={currentIndex} setSelected={goToNext} stories={i} />
                ))}
              </motion.div>
            </Carousel>
          </div>
          <PrevButton onClick={() => goToPrev(currentIndex - 1)}>
            <BackIcon />
          </PrevButton>
          <NextButton onClick={() => goToNext(currentIndex + 1)}>
            <NextIcon />
          </NextButton>
        </>
      </Modal>
    </>
  );
}

function Card({ i, selected, setSelected, stories }: any) {
  return (
    <AnimatePresence initial={false}>
      <motion.section
        animate={{
          scale: selected === i ? 1 : 0.66,
          filter: selected !== i ? 'grayscale(40%) contrast(90%)' : 'grayscale(0%) contrast(100%)'
        }}
        transition={{ duration: 0.4, ease: [0.04, 0.62, 0.23, 0.98] }}
      >
        <InstaStories
          stories={stories}
          isCurrent={selected === i}
          setCurrentCardIndex={setSelected}
        />
      </motion.section>
    </AnimatePresence>
  )
}

function CloseIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#FCFCFC"
        d="M12 9.334L21.334 0 24 2.666 14.666 12 24 21.334 21.334 24 12 14.666 2.666 24 0 21.334 9.334 12 0 2.666 2.666 0 12 9.334z"
      ></path>
    </svg>
  );
}

function BackIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32"
    >
      <path
        fill="#fff"
        fillOpacity="0.8"
        fillRule="evenodd"
        d="M16 0C7.163 0 0 7.163 0 16s7.163 16 16 16 16-7.163 16-16S24.837 0 16 0zm1.505 21.962a.889.889 0 001.257-1.257L14.057 16l4.705-4.705a.889.889 0 00-1.257-1.257l-5.333 5.333a.889.889 0 000 1.257l5.333 5.334z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

function NextIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32"
    >
      <path
        fill="#fff"
        fillOpacity="0.8"
        fillRule="evenodd"
        d="M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0zm-1.505 21.962a.889.889 0 01-1.257-1.257L17.943 16l-4.705-4.705a.889.889 0 011.257-1.257l5.333 5.333a.889.889 0 010 1.257l-5.333 5.334z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}